import { render, staticRenderFns } from "./DeliveryInputBusinOri.vue?vue&type=template&id=2d2282a3&scoped=true&"
import script from "./DeliveryInputBusinOri.vue?vue&type=script&lang=js&"
export * from "./DeliveryInputBusinOri.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInputBusinOri.vue?vue&type=style&index=0&id=2d2282a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2282a3",
  null
  
)

export default component.exports